import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d6ffb00e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d6ffb00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ffb00e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6ffb00e')) {
      api.createRecord('d6ffb00e', component.options)
    } else {
      api.reload('d6ffb00e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d6ffb00e&scoped=true&", function () {
      api.rerender('d6ffb00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nc33SeasUK53/JS/comp/DocBox.vue"
export default component.exports